import {LoginPanelProps} from "types/types";
import LoginBox from "../LoginBox";
import {CloseRoundIcon} from "assets/icon";
import {FormattedMessage} from "react-intl";
import {useDownMd} from "../../hooks/useLayout";

export default function LoginPanel({

                                       header,
                                       onClose,
                                       ...props
                                   }: LoginPanelProps) {

    const isDownMd = useDownMd()
    return <div className="matchid-login-panel">
        {header ? header : <div className="matchid-login-panel-header">
            <div className="matchid-login-panel-header-content">
                <div className="matchid-login-panel-header-title"><FormattedMessage id="loginTitle"/></div>
                <div className="matchid-login-panel-header-subtilte"><FormattedMessage id="loginTips"/></div>
            </div>
            {
                onClose && <div className={"matchid-login-panel-header-close"} onClick={onClose}><CloseRoundIcon size={isDownMd?24:30}/></div>
            }

        </div>}
        <div className="matchid-login-panel-divide"/>
        <div className={"matchid-login-panel-box"}>
            <LoginBox {...props}/>
        </div>
    </div>

}
